import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

// The ICS feed: subscribing to the whole schedule rather than adding events
// one at a time. Its per-event weblink still exists (the weblink menus' "Other"
// row); no icon declared → the 📆 emoji fallback, as today.
export const otherIcsDestination: DestinationModule = {
  platform: PlatformTypes.OtherIcs,
  behavior: 'feed',
  name: 'Other',
  shortName: 'Feed',
  addLabel: 'Add to other',
  description:
    'Add the ICS feed to any calendar. Changes to this schedule update your calendar within 24-48 hours.',
  syncKind: 'sync',
  isPinnable: true,
  persistedByServer: false,
  statusSource: 'localOnly',
  useIsAvailable: useAlwaysAvailable,
  weblink: { urlKey: 'other' },
};
